var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80645 11.7097V12.2903C5.80645 12.6097 6.06774 12.871 6.3871 12.871H11.129V17.6129C11.129 17.9323 11.3903 18.1935 11.7097 18.1935H12.2903C12.6097 18.1935 12.871 17.9323 12.871 17.6129V12.871H17.6129C17.9323 12.871 18.1935 12.6097 18.1935 12.2903V11.7097C18.1935 11.3903 17.9323 11.129 17.6129 11.129H12.871V6.3871C12.871 6.06774 12.6097 5.80645 12.2903 5.80645H11.7097C11.3903 5.80645 11.129 6.06774 11.129 6.3871V11.129H6.3871C6.06774 11.129 5.80645 11.3903 5.80645 11.7097ZM0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0C5.37097 0 0 5.37097 0 12ZM1.54839 12C1.54839 6.19839 6.25645 1.54839 12 1.54839C17.8016 1.54839 22.4516 6.25645 22.4516 12C22.4516 17.8016 17.7435 22.4516 12 22.4516C6.19839 22.4516 1.54839 17.7435 1.54839 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.0833e7d7b0c146621514098c4f065529.svg";
export { ForwardRef as ReactComponent };